import { Components } from "@mui/material";

const MuiAppBar: Components["MuiAppBar"] = {
  defaultProps: {
    elevation: 0,
  },
};

export { MuiAppBar };
